// Sidebar navigation (prototype order).
export const NAV = [
    {
        items: [
            { key: "today", label: "Today", icon: "ri-sun-line", path: "/today" },
            { key: "notes", label: "Daily notes", icon: "ri-sticky-note-line", path: "/notes" },
        ],
    },
    {
        title: "CRM",
        items: [
            { key: "people", label: "People", icon: "ri-contacts-line", path: "/crm/contacts", badge: "contacts" },
            { key: "companies", label: "Companies", icon: "ri-building-line", path: "/crm/companies", badge: "companies" },
            { key: "leads", label: "Leads", icon: "ri-funds-line", path: "/crm/leads", badge: "leads", badgeTitle: "Stalled or no next step" },
            { key: "signals", label: "Signals", icon: "ri-radar-line", path: "/crm/signals" },
            { key: "imports", label: "Imports", icon: "ri-upload-cloud-2-line", path: "/crm/imports" },
        ],
    },
    {
        title: "Reports",
        items: [
            { key: "brief", label: "Weekly brief", icon: "ri-calendar-check-line", path: "/reports/weekly-brief" },
            { key: "funnel", label: "Funnel", icon: "ri-filter-3-line", path: "/reports/funnel" },
        ],
    },
    {
        title: "Content",
        items: [
            { key: "articles", label: "Articles", icon: "ri-article-line", path: "/content/articles" },
            { key: "social", label: "Social posts", icon: "ri-share-line", path: "/content/social" },
        ],
    },
    {
        title: "Talent",
        items: [
            { key: "jobs", label: "Job posts", icon: "ri-briefcase-line", path: "/talent/jobs" },
            { key: "hiring", label: "Hiring companies", icon: "ri-community-line", path: "/talent/companies" },
        ],
    },
];

export const NAV_BOTTOM = [{ key: "settings", label: "Settings", icon: "ri-settings-3-line", path: "/settings" }];

// Flat list for the command palette's "Go to".
export const NAV_PAGES = [
    ...NAV.flatMap((s) => s.items.map((i) => ({ ...i, group: s.title || "" }))),
    { key: "duplicates", label: "Duplicates", group: "CRM", icon: "ri-git-merge-line", path: "/crm/imports/duplicates" },
    { key: "settings", label: "Settings", group: "", icon: "ri-settings-3-line", path: "/settings" },
    { key: "trash", label: "Trash", group: "Settings", icon: "ri-delete-bin-line", path: "/settings/trash" },
    { key: "search", label: "Search", group: "", icon: "ri-search-line", path: "/search" },
    { key: "settings-reports", label: "Reports", group: "Settings", icon: "ri-bar-chart-box-line", path: "/settings/reports" },
    { key: "claude", label: "Claude access", group: "Settings", icon: "ri-key-2-line", path: "/settings/claude" },
    { key: "privacy", label: "Privacy", group: "Settings", icon: "ri-shield-keyhole-line", path: "/settings/privacy" },
];
